
  <h1>Would you like to order pizza?</h1>
  <mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close('No!')">No</button>
    <button mat-button color="primary" (click)="dialogRef.close('Yes!')">Yes</button>
  </mat-dialog-actions>
  